/* Decorative enhancements never gate content, navigation or purchasing. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Set();
  function play(node, frames, options) {
    if (reduced.matches || !node.animate) return;
    const animation = node.animate(frames, options);
    running.add(animation);
    animation.finished.catch(() => {}).finally(() => running.delete(animation));
  }

  /* Reveal on scroll is CSS since Round 3 (sp-sport.css, "Scroll-linked reveal"; sp-refinements.css until Round 8): a block's fade is tied to its
    position on screen, not to a timer, so nothing in view can ever be blank, whatever the scroll speed. It is armed on
    the first scroll only: until then the page is drawn exactly as it is (what accessibility checkers such as
    Lighthouse read). At that first scroll every block already on screen, above it or within 300px below it is marked as
    seen and keeps no fade; the blocks still below the window fade in as they arrive. Keep REVEAL in step with the CSS selector list. */
  const REVEAL =
    'main .sp-section-heading,main .sp-product-grid .sp-card,main .sp-info-block,main .sp-info-media,main .sp-faq-group,main .sp-manifesto,.sp-not-found-body,.sp-spirit>.sp-kicker,.sp-spirit>div>div,.sp-foot-main>*,.product-information__more>*';
  if (window.CSS?.supports?.('animation-timeline: view()')) {
    const arm = () => {
      removeEventListener('scroll', arm);
      document.querySelectorAll(REVEAL).forEach((node) => {
        // On screen, above it, or within 300px below it (about to arrive): never faded (Round 3A).
        if (node.getBoundingClientRect().top < innerHeight + 300) node.dataset.spSeen = '';
      });
      document.documentElement.classList.add('sp-reveal-armed');
    };
    addEventListener('scroll', arm, { passive: true });
  }

  // The brand statement's lines keep their own line-by-line entrance (Round 4: the slim hero has none, and no button pull).
  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              entry.target.dataset.spRevealed = 'true';
              revealLines(entry.target);
            });
          },
          { threshold: 0.12 },
        )
      : null;
  function revealLines(heading) {
    const mobile = matchMedia('(max-width: 749px)').matches;
    heading.querySelectorAll('.sp-motion-line').forEach((line, index) =>
      play(
        line,
        [
          { opacity: 0.6, transform: `translateY(${mobile ? 7 : 12}px)` },
          { opacity: 1, transform: 'none' },
        ],
        { duration: mobile ? 330 : 450, delay: Math.min(index, 1) * 60, easing: 'cubic-bezier(.22,1,.36,1)' },
      ),
    );
  }
  function initialize(root = document) {
    root.querySelectorAll('.sp-spirit h2').forEach((node) => {
      if (node.dataset.spObserved) return;
      node.dataset.spObserved = 'true';
      observer?.observe(node);
    });
  }
  // A filter or sort change: a quick fade on the cards now showing.
  document.addEventListener('sp:catalog-change', (event) => {
    event.target.querySelectorAll('.sp-card:not([hidden])').forEach((card, index) => {
      card.getAnimations().forEach((animation) => animation.cancel());
      play(card, [{ opacity: 0.7 }, { opacity: 1 }], {
        duration: 160,
        delay: Math.min(index, 3) * 20,
        easing: 'ease-out',
      });
    });
  });
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    running.forEach((animation) => animation.cancel());
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sp-observed]').forEach((node) => observer?.unobserve(node));
  });
  initialize();
})();
